import * as React from 'react';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, children, ...props }, ref) => {
    return (
      <div className={className}>
        <input
          type={type}
          className={
            'peer/field block relative w-full px-3 bg-transparent text-white font-medium group-disabled/input:text-[rgba(255,255,255,0.5)] ring-offset-background placeholder:text-[rgba(255,255,255,0.5)] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none z-10 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [appearance:textfield]'
          }
          ref={ref}
          {...props}
        />
        {children}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
